import { useEffect } from 'react';
import { shouldPrefilValueBeShown } from '../Helpers';

export const usePrefilledValue = ({ fieldName, form, prefilledValue }) => {
    const showPrefilledValue = shouldPrefilValueBeShown(fieldName, form);

    useEffect(() => {
        if (showPrefilledValue) {
            form.change(fieldName, prefilledValue);
        }
    }, [showPrefilledValue]);

    return { showPrefilledValue };
};
